import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { useIsServerUpQuery, useLazyIsServerUpQuery } from './api';
import { useEffect } from 'react';
import { useIsAuthenticated } from '../user/use';

export function useIsMaintenance() {
  return (
    useSelector((state: RootState) => state.appMeta)?.isMaintenance ?? false
  );
}

export function useIsCloudflareBlocked() {
  return (
    useSelector((state: RootState) => state.appMeta)?.isCloudflareBlocked ??
    false
  );
}

export function useCheckMaintenance() {
  const { data, refetch } = useIsServerUpQuery(undefined, {
    pollingInterval: 5 * 60 * 1000,
  });

  const expectedDate = useSelector(
    (state: RootState) => state.appMeta,
  )?.retryAfter;

  useEffect(() => {
    if (expectedDate) {
      const timeout = setTimeout(refetch, expectedDate - Date.now());
      return () => clearTimeout(timeout);
    } else return () => {};
  }, [expectedDate, refetch]);

  useEffect(() => {
    if (data === 'OK') {
      window.location.href = '/';
    }
  }, [data]);
}

export function useMaybeDelayedCheckServerStatus() {
  const [check] = useLazyIsServerUpQuery();
  const isAuthenticated = useIsAuthenticated();
  useEffect(() => {
    // wtf is this?
    // well, on some non-logged-in pages we do not make any backend requests at all
    // so to check that the maintenancer is on, we fire a single request
    // then an interceptor will take care of everythign else
    !isAuthenticated && setTimeout(check, 1000);
  }, []);
}
